import {ServiceProviderRepository} from '../repository/ServiceProviderRepository';
import {ServiceProvider} from '../models/serviceProvider.model';

export class GetAllServiceProvidersUseCase {
  constructor (private serviceProviderRepository: ServiceProviderRepository) {}

  async execute (page = 1, limit = 20): Promise<{ items: ServiceProvider[]; pagination?: any }> {
    return await this.serviceProviderRepository.getAll(page, limit);
  }
}
